import { useTemperature } from '../../hooks/useTemperature';
import { Button, ButtonHole, ButtonTop, Img } from './bodyStyles';
import {
  ButtonWrapper,
  ControllerTitle,
  ControllerTitleWrapper,
  InstantHeatAndFanOnlyWrapper,
  InstantHeatWrapper,
  SnowSensorInner,
  SnowSensorWrapper,
  TempInput,
  TitleAndInputWrapper,
} from './gasControlStyles';
import { programImage } from './machineCardFacts';

/** The collapsed TGS card's instant heat + fan row and snow sensor button. */
const GasControls = ({
  device,
  programsLocked: locked,
  instantTemp,
  editInstantTemp,
  submitInstantHeat,
  toggleFan,
  toggleSnowSensor,
}) => {
  const { instantHeat, snowSensor, fanOnly } = device;
  const { isF } = useTemperature();

  return (
    <>
      <InstantHeatAndFanOnlyWrapper isOff={locked}>
        <InstantHeatWrapper
          onSubmit={submitInstantHeat}
          isActivated={instantHeat.isActivated}
          isReady={instantHeat.isReady}
          isOff={locked}
        >
          <Button onClick={submitInstantHeat} isActivated={instantHeat.isActivated} isOff={locked}>
            <ButtonHole
              isActivated={instantHeat.isActivated}
              isReady={instantHeat.isReady}
              isOff={locked}
            >
              <ButtonTop isActivated={instantHeat.isActivated} isOff={locked}>
                <Img src={programImage('instantHeat', locked)} />
              </ButtonTop>
            </ButtonHole>
          </Button>

          <TitleAndInputWrapper>
            <ControllerTitleWrapper isActivated={instantHeat.isActivated} isOff={locked}>
              <ControllerTitle
                isActivated={instantHeat.isActivated}
                isReady={instantHeat.isReady}
                isOff={locked}
              >
                instant <br></br> heat
              </ControllerTitle>
            </ControllerTitleWrapper>

            <TempInput
              type='text'
              placeholder={isF ? '0 °F' : '0 °C'}
              value={instantTemp}
              onChange={(e) => editInstantTemp(e.target.value)}
              isActivated={instantHeat.isActivated}
              isOff={locked}
            />
          </TitleAndInputWrapper>
        </InstantHeatWrapper>

        <ButtonWrapper isActivated={fanOnly} isOff={locked}>
          <Button onClick={toggleFan} isActivated={fanOnly} isOff={locked}>
            <ButtonHole isActivated={fanOnly} isOff={locked}>
              <ButtonTop isActivated={fanOnly} isOff={locked}>
                <Img src={programImage('fanOnly', locked)} />
              </ButtonTop>
            </ButtonHole>
          </Button>
        </ButtonWrapper>
      </InstantHeatAndFanOnlyWrapper>

      <SnowSensorWrapper isOff={locked}>
        <SnowSensorInner
          isActivated={snowSensor.isActivated}
          isReady={snowSensor.isReady}
          isOff={locked}
        >
          <Button onClick={toggleSnowSensor} isOff={locked}>
            <ButtonHole isOff={locked}>
              <ButtonTop isOff={locked}>
                <Img src={programImage('snowSensor', locked)} />
              </ButtonTop>
            </ButtonHole>
          </Button>
        </SnowSensorInner>
      </SnowSensorWrapper>
    </>
  );
};

export default GasControls;
